class Controller {
  constructor() {
    this.filterAvailableReasons = this.filterAvailableReasons.bind(this);
  }

  addToReasons(reason) {
    if (!this.form.dirty) this.form.$setDirty();
    reason.taken[this.rule.ride_category] = true;
    this.rule.reasons.push(reason);
  }

  removeFromReasons(reason, index) {
    if (!this.form.dirty) this.form.$setDirty();
    this.rule.reasons.splice(index, 1);
    reason.taken[this.rule.ride_category] = false;
  }

  filterAvailableReasons(reason) {
    return !reason.taken[this.rule.ride_category];
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/pages/fulfillmentPlan/reasonsDialog/reasonsDialog.controller.js